// Photo filenames for Fire Hogs Memorial
const FIRE_HOGS_MEMORIAL = [
  'firehogs-200_15566481863_c.jpg',
  'firehogs-201_15998958980_c.jpg',
  'firehogs-202_16000221769_c.jpg',
  'firehogs-203_16186279435_l.jpg',
  'firehogs-204_15998958730_z.jpg',
  'firehogs-205_16186279305_c.jpg',
  'firehogs-207_16160469536_z.jpg',
  'firehogs-208_16000484327_c.jpg',
  'firehogs-209_16000223399_z.jpg',
  'firehogs-210_16185520292_c.jpg',
  'firehogs-211_15563903834_z.jpg',
  'firehogs-212_16186281095_c.jpg',
  'firehogs-213_16160469096_z.jpg',
  'firehogs-214_16000222979_z.jpg',
  'firehogs-215_15563903544_z.jpg',
  'firehogs-216_16000483657_z.jpg',
  'firehogs-217_16000222779_z.jpg',
  'firehogs-218_15563903364_z.jpg',
  'firehogs-219_15998830408_z.jpg',
  'firehogs-220_15563903304_z.jpg',
  'firehogs-221_16160468456_z.jpg',
  'firehogs-222_15998959770_z.jpg',
  'firehogs-223_16160468356_z.jpg',
  'firehogs-224_16160468266_z.jpg',
  'firehogs-225_16000483247_z.jpg',
  'firehogs-226_15998830078_z.jpg',
  'firehogs-227_15566482323_z.jpg',
  'firehogs-228_16160468106_z.jpg',
  'firehogs-229_15998829998_z.jpg',
  'firehogs-230_16184395221_z.jpg',
  'firehogs-231_16185519112_z.jpg',
  'firehogs-232_16184395131_z.jpg',
  'firehogs-233_16000482877_z.jpg',
  'firehogs-234_15998959170_c.jpg',
  'firehogs-235_16186279715_c.jpg',
];

export default FIRE_HOGS_MEMORIAL;
